"use client";

import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const partners = [{
  id: 1,
  name: "Aura Resorts",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_logo_aura.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_logo_aura.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_logo_aura.png-wvc-sizes",
  tagline: "Exclusive Retreats"
}, {
  id: 2,
  name: "Lumina Aviation",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_logo_lumina.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_logo_lumina.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_logo_lumina.png-wvc-sizes",
  tagline: "Private Charters"
}, {
  id: 3,
  name: "Vela Yachts",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_logo_vela.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_logo_vela.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_logo_vela.png-wvc-sizes",
  tagline: "Maritime Excellence"
}, {
  id: 4,
  name: "Oakhaven Estates",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_logo_oakhaven.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_logo_oakhaven.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_logo_oakhaven.png-wvc-sizes",
  tagline: "Heritage Properties"
}, {
  id: 5,
  name: "Caelum Concierge",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_logo_caelum.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_logo_caelum.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_logo_caelum.png-wvc-sizes",
  tagline: "Global Access"
}, {
  id: 6,
  name: "Solstice Spas",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_logo_solstice.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_logo_solstice.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/partner_logo_solstice.png-wvc-sizes",
  tagline: "Holistic Wellness"
}];
export default function SignaturePartnerships() {
  return <section id="signature-partnerships" className="bg-foreground py-24 md:py-32 text-background overflow-hidden">
      <div className="container mx-auto px-4 md:px-8">
        <div className="mb-16 text-center">
          <h2 className="font-default text-2xl md:text-3xl font-semibold text-background/90 mb-6 tracking-wide">
            Signature Partnerships
          </h2>
          <div className="w-12 h-px bg-background/20 mx-auto"></div>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true,
        dragFree: true
      }} className="w-full max-w-6xl mx-auto">
          <CarouselContent className="-ml-4 md:-ml-8">
            {partners.map((partner, i) => <CarouselItem key={partner.id} data-index={i} className="pl-4 md:pl-8 basis-1/2 md:basis-1/3 lg:basis-1/4">
                <div className="flex flex-col items-center justify-center p-6 h-full group cursor-grab active:cursor-grabbing">
                  <div className="relative w-32 h-24 mb-8 flex items-center justify-center opacity-60 group-hover:opacity-100 transition-opacity duration-700 ease-in-out">
                    <img src={partner.logo} data-wvc-srcset={partner.srcset} data-wvc-sizes={partner.sizes} alt={`${partner.name} logo`} className="max-w-full max-h-full object-contain filter grayscale contrast-200 brightness-200" loading="lazy" />
                  </div>
                  <p className="font-mono text-[0.8rem] tracking-[0.1em] text-background/50 text-center uppercase group-hover:text-background/80 transition-colors duration-700">
                    {partner.tagline}
                  </p>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          <div className="hidden md:block">
            <CarouselPrevious className="border-background/20 text-background hover:bg-background/10 hover:text-background bg-transparent -left-16" />
            <CarouselNext className="border-background/20 text-background hover:bg-background/10 hover:text-background bg-transparent -right-16" />
          </div>
        </Carousel>
      </div>
    </section>;
}